import {
  mapState,
  mapMutations
} from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import api from '../service/services'
import $ from 'jquery'
import swal from 'sweetalert2'

export default {
  data() {
    return {
      step: '',
      timeleft:3,
      countdowninterval:'',
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState([
      'isLoading',
      'lang',
      'IDWallet',
      'SaleID',
      'SaleType',
      'PaymentType',
      'accessToken',
      'AmountPayment',
      'reponseStatus',
      'sale_info',
      'printer_step',
      'sale_pay',
      'config',
      'sale_subs_slip',
      'txn_id',
      'flag_cash'
    ]),
    ...mapMutations(['onMessageWs'])
  },
  methods: {
    TESTProcess() {
      console.log('this.$store.state.aclthis.$store.state.acl',this.$store.state.acl)
      console.log('salesubs',this.$store.state.sale_subs[0])
      if(this.$store.state.sale_subs[0].item_id == "1000629" || this.$store.state.sale_subs[0].item_name == "รายครั้ง"){
        $("#modalquickpay").modal("show");
      this.countdowninterval = setInterval(()=> {
        document.getElementById("countdown").innerHTML = this.timeleft + " seconds remaining";
        this.timeleft--;
        if(this.timeleft == 0){
          clearInterval(this.countdowninterval)
        }
      }, 1000);
      }
      // return
      setTimeout(() => {
        $("#modalquickpay").modal("hide");
        clearInterval(this.countdowninterval)
        this.$store.commit('clearState')
        clearInterval(this.step)
        switch (this.lang) {
          case 0:
            this.sayLang('Thankyou')
            break
          case 2:
          this.sayLang('謝謝')

            break
          default:
          this.sayLang('ขอบคุณค่ะ')
            break
        }
        this.$router.push({
          name: 'Main'
        })
      }, this.timeleft * 1000);
      //20000 sec
      //   }.bind(this), 2500)
      // }.bind(this), 4000)
    },
    websocket_onmessage() {
      this.$socket.onmessage = skResult => {
        this.$store.commit('onMessageWs', JSON.parse(skResult.data))
      }
    },
    Payment() {
      this.Soundclick()
      $('#walletid').modal('hide')
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }
      if (this.SaleID == 1) {
        var mode = 'Deposit'
        var payment_type_text = 'cash'
        var type_text = 'Wallet'
        switch (this.lang) {
          case 0:
            payment_type_text = 'cash'
            type_text = 'Wallet'
            mode = 'Deposit'
            break
          case 1:
            payment_type_text = 'เงินสด'
            type_text = 'เติมเงิน Wallet'
            mode = 'เติมเงิน'
            break
          case 2:
            payment_type_text = '現金'
            type_text = 'Wallet'
            mode = '存款'
            break
        }
        this.$store.state.total = this.$store.state.AmountPayment
        this.$store.state.sale_subs = [{
          line: 1,
          item_id: '0',
          item_name: payment_type_text,
          qty: 1,
          price_id: 1,
          price_name: type_text,
          price: parseFloat(this.AmountPayment),
          unit: ''
        }]
      }

      var saletype = ''
      switch (this.SaleID) {
        case 1:
          saletype = 'deposit_cash'
          break
        case 2:
          saletype = 'sale_cash'
          break
        case 3:
          saletype = ''
          break
        case 4:
          saletype = 'sale_cash'
          break
        case 5:
          saletype = 'sale_cash'
          break
        default:
          saletype = 'deposit'
          break
      }

      if (this.$store.state.SaleID !== 5) {
        this.$store.state.ref_number = this.$store.state.txn_id
        this.status_partner = false
      } else {
        this.status_partner = true
      }
      console.log(this.$store.state.IDWallet)
      console.log(this.$store.state.IDWallet.length)
      if (this.$store.state.IDWallet.length > 0) {
        var numberPhone = this.IDWallet.substring(1, this.$store.state.length)
        var phone = '+66' + numberPhone
      } else {
        alert("numberPhone :", this.$store.state.IDWallet)
        swal.fire({
              title: 'ระบบมีปัญหา?',
              text: 'กรุณาติดต่อเจ้าหน้าที่',
              type: 'Error!!',
              showCancelButton: false,
            })
        return
      }
      this.payload = {
        shift_uuid: this.$store.state.shift_uuid,
        ref_number: this.$store.state.ref_number,
        txn_id: this.$store.state.txn_id,
        type: saletype,
        partner: this.status_partner,
        member_phone: phone,
        amount: parseFloat(this.$store.state.total),
        payment_received: parseFloat(this.$store.state.AmountPayment),
        payment_change: parseFloat(this.$store.state.total) - parseFloat(this.$store.state.AmountPayment),
        flag_cash: this.$store.state.flag_cash,
        flag_member: this.$store.state.flag_member,
        payment: {
          currency: 'THB',
          b1000: this.sale_pay.b1000,
          b500: this.sale_pay.b500,
          b100: this.sale_pay.b100,
          b50: this.sale_pay.b50,
          b20: this.sale_pay.b20,
          c10: this.sale_pay.c10,
          c5: this.sale_pay.c5,
          c2: this.sale_pay.c2,
          c1: this.sale_pay.c1,
          c050: 0,
          c025: 0
        },
        pay_change: {
          b1000: 0,
          b500: 0,
          b100: 0,
          b50: 0,
          b20: 0,
          c10: 0,
          c5: 0,
          c2: 0,
          c1: 0,
          c050: 0,
          c025: 0
        },
        items: this.$store.state.sale_subs
      }
      console.log(this.payload)
      console.log(JSON.stringify(this.payload))
      console.log(JSON.stringify(this.$store.state.sale_subs_slip))
      if (this.$store.state.AmountPayment >= this.$store.state.total) {
        api.closeSaleV2(
          this.payload,
          header,
          result => {
            console.log(JSON.stringify(result))
            if (result.response == 'success') {
              // this.$socket.sendObj({
              //   command: 'receive_close'
              // })
              if(this.SaleID == 1){

              } else if (this.$store.state.IDWallet == this.$store.state.config.client.telephone) {
              // if (this.$store.state.IDWallet == "0613351889") {
                var data_slip = {
                  "command": "print_slip",
                  "data": {
                    "client_tax_id": "",
                    "shop_title": this.$store.state.config.client.shop_title,
                    "shop_website": this.$store.state.config.client.shop_website,
                    "logo_image_width": 300,
                    "total": parseFloat(this.$store.state.total),
                    "payment": parseFloat(this.$store.state.AmountPayment),
                    "change": (parseFloat(this.$store.state.total)-parseFloat(this.$store.state.AmountPayment))*(-1),
                    "type": "take_home",
                    "unchange": (parseFloat(this.$store.state.total)-parseFloat(this.$store.state.AmountPayment))*(-1),
                    "status": 0,
                    "queue_no": result.queue,
                    "sale_pay": {
                      "B1000": this.sale_pay.b1000,
                      "B500": this.sale_pay.b500,
                      "B100": this.sale_pay.b100,
                      "B50": this.sale_pay.b50,
                      "B20": this.sale_pay.b20,
                      "C10": this.sale_pay.c10,
                      "C5": this.sale_pay.c5,
                      "C2": this.sale_pay.c2,
                      "C1": this.sale_pay.c1,
                    },
                    "sale_subs": this.$store.state.sale_subs_slip
                  }
                }
                console.info(JSON.stringify(data_slip))
                this.$socket.sendObj(data_slip)
                // var data_slip = {
                //   "command": "print_unpaid_change",
                //   "data": {
                //     "queue_number": result.queue,
                //     "shop_title": this.$store.state.config.client.shop_title,
                //     "vending_id": 102,
                //     "unpaid_change": (parseFloat(this.$store.state.total)-parseFloat(this.$store.state.AmountPayment))*(-1),
                //     "mode": 0
                //   }
                // }
              } else {
                var data_slip = {
                  "command": "print_slip",
                  "data": {
                    "client_tax_id": "",
                    "shop_title": this.$store.state.config.client.shop_title,
                    "shop_website": this.$store.state.config.client.shop_website,
                    "logo_image_width": 300,
                    "total": parseFloat(this.$store.state.total),
                    "payment": parseFloat(this.$store.state.AmountPayment),
                    "change": (parseFloat(this.$store.state.total)-parseFloat(this.$store.state.AmountPayment))*(-1),
                    "type": "take_home",
                    "unchange": 0,
                    "status": 0,
                    "queue_no": result.queue,
                    "sale_pay": {
                      "B1000": this.sale_pay.b1000,
                      "B500": this.sale_pay.b500,
                      "B100": this.sale_pay.b100,
                      "B50": this.sale_pay.b50,
                      "B20": this.sale_pay.b20,
                      "C10": this.sale_pay.c10,
                      "C5": this.sale_pay.c5,
                      "C2": this.sale_pay.c2,
                      "C1": this.sale_pay.c1,
                    },
                    "sale_subs": this.$store.state.sale_subs_slip
                  }
                }
                console.info(JSON.stringify(data_slip))
                this.$socket.sendObj(data_slip)
              }
              if (this.$store.state.SaleID == 5) {
                const obj = {
                  ref_number: this.$store.state.ref_number,
                  status: 'PROCESSING'
                }
                api.getReceiveC9(
                  obj,
                  header,
                  result => {
                    console.log(result)
                    this.$store.state.history_page = 'Cash'
                    this.$router.push({
                      name: 'ProcessCash'
                    })
                  },
                  error => {
                    alert(JSON.stringify(error))
                  }
                )
              } else {
                console.log(this.$store.state.acl)
                if (this.$store.state.acl === 1) {
                  this.$socket.sendObj({
                    command: 'open_cash_box',
                    data: 10
                  })
                }
                // this.$store.state.history_page = 'Cash'
                // this.$router.push({
                //   name: 'ProcessCash'
                // })
              }
            } else {
              alert(JSON.stringify(result))
            }
            this.$store.state.isLoading = false
          },
          error => {
            console.log(JSON.stringify(error))
            this.$store.state.isLoading = false
            alert(JSON.stringify(error))
          }
        )
      }
    },
  },
  mounted() {
    this.websocket_onmessage()
    this.Payment()
    setTimeout(function () {
      // this.printBill()
      this.$store.state.printer_step = 2
    }.bind(this), 2000);
    this.step = setInterval(function () {
      if (this.printer_step == 2) {
        this.$store.state.printer_step = 1
        this.TESTProcess()
      }
    }.bind(this), 1000)
  }
}



// WEBPACK FOOTER //
// ./src/js/pc.js